import * as React from 'react';
import { View, Text, Modal } from 'react-native';
import { Button, Icon } from 'react-native-elements';
import { styles } from 'styles/components/actionModal';
import useMediumScreen from 'hooks/useMediumScreen';
import ActionModalProps from 'types/components/ActionModalProps';
import AppContext from 'contexts/AppContext';
import OrderContext from 'contexts/OrderContext';
import { useTranslation } from 'react-i18next';

export default ({ modalData }: ActionModalProps): JSX.Element => {
  const { setModalData } = React.useContext(AppContext);
  const { currentOrder } = React.useContext(OrderContext);
  const isVisible = modalData ? true : false;
  const mediumScreen = useMediumScreen();

  const { t } = useTranslation();

  const confirmHandleModal = async () => {
    if (modalData) {
      await modalData.action();
      setModalData(null);
    }
  };

  const renderModal = (): JSX.Element => {
    return (
      <View style={mediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
        <View style={[styles.modaIconContainer, { backgroundColor: modalData?.generalColor ?? '#FFFFFF' }]}>
          <Icon
            name={currentOrder ? 'shopping-cart' : 'help-circle-outline'}
            type={!currentOrder ? 'ionicon' : undefined}
            color={'#FFFFFF'}
            size={35}
            containerStyle={styles.iconContainer}
          />
        </View>
        <View style={styles.modalTextContainer}>
          <Text style={styles.modalText}>
            {t('modal-message-init')} {modalData?.description}?
          </Text>
        </View>
        <View style={styles.modalBtnContainer}>
          <Button
            title={t('cancel-upper')}
            onPress={() => setModalData(null)}
            buttonStyle={mediumScreen ? styles.cancelBtnStyle : styles.cancelBtnStyleSmall}
            titleStyle={[styles.cancelBtnText, { color: modalData?.generalColor }]}
          />
          <Button
            title={t('accept-upper')}
            onPress={confirmHandleModal}
            buttonStyle={mediumScreen ? styles.confirmBtnStyle : styles.confirmBtnStyleSmall}
            titleStyle={[styles.confirmBtnText, { color: modalData?.generalColor }]}
          />
        </View>
      </View>
    );
  };

  return (
    <Modal visible={isVisible} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>{renderModal()}</View>
    </Modal>
  );
};
